const skins = ['light', 'medium', 'dark', 'promo']

export const variants = [
  { name: 'light' },
  { name: 'medium', variants: ['1', '2', '3', '4', '5'] },
  { name: 'dark' },
  { name: 'promo', variants: ['1', '2', '3', '4'] },
]

export default skins
